import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CareerSection from './components/CareerSection';
import VisionSection from './components/VisionSection';
import HobbiesSection from './components/HobbiesSection';
import InstagramSection from './components/InstagramSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <CareerSection />
      <VisionSection />
      <HobbiesSection />
      <InstagramSection />
      <Footer />
    </div>
  );
}